// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.97.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.97.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_searchBox__cqqIX {
  display: flex;
  padding: 18px 16px;
}
.style_searchBox__cqqIX .style_searchBlockFrame__B82wq {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  caret-color: black;
  border-radius: 24px;
  gap: 8px;
  padding: 0 10px;
  border: 1px solid #e9e9eb;
  position: relative;
}
.style_searchBox__cqqIX .style_searchBlockFrame__B82wq .style_searchBlockCtrl__msExZ {
  border: 0 none;
  background-color: #ffffff;
  resize: none;
  display: flex;
  padding-left: 0;
  padding-right: 23px;
}
.style_searchBox__cqqIX .style_searchBlockFrame__B82wq .style_searchBlockIco__FtkQK {
  display: flex;
  align-items: center;
  justify-content: center;
  height: fit-content;
  left: 10px;
}
.style_searchBox__cqqIX .style_searchBlockFrame__B82wq .style_searchBlockIco__FtkQK i {
  display: flex;
  align-items: center;
  justify-content: center;
}
.style_searchBox__cqqIX .style_searchBlockFrame__B82wq .style_searchBlockClear__l9lct {
  cursor: pointer;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  height: fit-content;
  right: 10px;
}
.style_searchBox__cqqIX .style_searchBlockFrame__B82wq .style_searchBlockClear__l9lct i {
  z-index: 2;
}
.style_searchBox__cqqIX .style_searchBlockFrame__B82wq .style_searchBlockClear__l9lct:before {
  content: "";
  top: 50%;
  left: 50%;
  position: absolute;
  background-color: transparent;
  height: 20px;
  width: 20px;
  border-radius: 20px;
  transform: translate(-52%, -57%);
  transition: all 0.5s;
  z-index: 1;
}
.style_searchBox__cqqIX .style_searchBlockFrame__B82wq .style_searchBlockClear__l9lct:hover:before {
  content: "";
  top: 50%;
  left: 50%;
  position: absolute;
  background-color: #eaedef;
  height: 20px;
  width: 20px;
  border-radius: 20px;
  transform: translate(-52%, -57%);
  transition: all 0.5s;
}`, "",{"version":3,"sources":["webpack://./src/components/Contacts/SearchBlock/style.module.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,kBAAA;AADF;AAGE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;AADJ;AAGI;EACE,cAAA;EACA,yBCpBE;EDqBF,YAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;AADN;AAII;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AAFN;AAIM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAFR;AAMI;EACE,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AAJN;AAMM;EACE,UAAA;AAJR;AAOM;EACE,WAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,6BAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,gCAAA;EACA,oBAAA;EACA,UAAA;AALR;AAQM;EACE,WAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,yBCnEM;EDoEN,YAAA;EACA,WAAA;EACA,mBAAA;EACA,gCAAA;EACA,oBAAA;AANR","sourcesContent":["@import '../../../variables.scss';\n\n.searchBox {\n  display: flex;\n  padding: 18px 16px;\n\n  .searchBlockFrame {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    caret-color: black;\n    border-radius: 24px;\n    gap: 8px;\n    padding: 0 10px;\n    border: 1px solid $gray-box-border;\n    position: relative;\n\n    .searchBlockCtrl {\n      border: 0 none;\n      background-color: $white;\n      resize: none;\n      display: flex;\n      padding-left: 0;\n      padding-right: 23px;\n    }\n\n    .searchBlockIco {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      height: fit-content;\n      left: 10px;\n\n      i {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n    }\n\n    .searchBlockClear {\n      cursor: pointer;\n      position: absolute;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      height: fit-content;\n      right: 10px;\n\n      i {\n        z-index: 2;\n      }\n\n      &:before {\n        content: '';\n        top: 50%;\n        left: 50%;\n        position: absolute;\n        background-color: transparent;\n        height: 20px;\n        width: 20px;\n        border-radius: 20px;\n        transform: translate(-52%, -57%);\n        transition: all 0.5s;\n        z-index: 1;\n      }\n\n      &:hover:before {\n        content: '';\n        top: 50%;\n        left: 50%;\n        position: absolute;\n        background-color: $gray-active;\n        height: 20px;\n        width: 20px;\n        border-radius: 20px;\n        transform: translate(-52%, -57%);\n        transition: all 0.5s;\n      }\n    }\n  }\n}\n","$white: #ffffff;\n$black: #000000;\n\n$gray-background: #f5f5f7;\n$gray-border: #dce1e6;\n$gray-box-border: #e9e9eb;\n$gray-active: #eaedef;\n$active-color: #5f8fdf;\n$active-color-op: rgba(95, 143, 223, 0.4);\n// $active-color: #00ff95;\n$sender-message-color: #cce4ff;\n\n$text-color-800: #4a596a;\n$text-color-700: #626d7a;\n$text-color-600: #909399;\n\n$active-color-2: #ec205f;\n\n// $header-color: #add8e6;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchBox": `style_searchBox__cqqIX`,
	"searchBlockFrame": `style_searchBlockFrame__B82wq`,
	"searchBlockCtrl": `style_searchBlockCtrl__msExZ`,
	"searchBlockIco": `style_searchBlockIco__FtkQK`,
	"searchBlockClear": `style_searchBlockClear__l9lct`
};
export default ___CSS_LOADER_EXPORT___;
